export default {
  DOWNLOAD: 'Scaricare',
  PROCESSING: 'Elaborazione',
  GENERAL_EVENT_INFO: 'Evento generale info',
  EVENT_DETAILS: 'Dettagli Evento',
  GENERATE_NEW: 'Generare nuovi',
  REPORT_NOT_GENERATED: 'Il tuo rapporto non è stato ancora generato o finora non è stato acquisito alcun derivazioni. Riprova più tardi.',
  REPORT_DOWNLOADED: 'Rapporto scaricato con successo',
  DOWNLOAD_REPORT: 'Scarica Rapporto',
  LAST_GENERATED: 'Ultimo Rapporto generato in',
  DOWNLOAD_REPORT_INFO: "La generazione di un nuovo rapporto potrebbe richiedere un po' di tempo, quindi tieni aperta questa scheda."
}
